import React from "react";

const HamburgerIcon = ({
  width = 32,
  height = 10,
  color = "",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 10"
    fill="none"
  >
    <path
      d="M1.54839 0C0.693244 0 0 0.353463 0 0.789474C0 1.22548 0.693244 1.57895 1.54839 1.57895V0ZM30.4516 1.57895C31.3067 1.57895 32 1.22548 32 0.789474C32 0.353463 31.3067 0 30.4516 0V1.57895ZM1.54839 4.21053C0.693244 4.21053 0 4.564 0 5C0 5.436 0.693244 5.78947 1.54839 5.78947V4.21053ZM26.3226 5.78947C27.1777 5.78947 27.871 5.436 27.871 5C27.871 4.564 27.1777 4.21053 26.3226 4.21053V5.78947ZM1.54839 8.42105C0.693244 8.42105 0 8.77453 0 9.21053C0 9.64653 0.693244 10 1.54839 10V8.42105ZM16 10C16.8551 10 17.5484 9.64653 17.5484 9.21053C17.5484 8.77453 16.8551 8.42105 16 8.42105V10ZM1.54839 1.57895H30.4516V0H1.54839V1.57895ZM1.54839 5.78947H26.3226V4.21053H1.54839V5.78947ZM1.54839 10H16V8.42105H1.54839V10Z"
      fill="#303030"
    />
  </svg>
);

export default HamburgerIcon;
